/* unplugin-vue-components disabled */// extracted by extract-css-chunks-webpack-plugin
module.exports = {"ControlButtons":"ControlButtons_L5Lbt"};